import React from 'react';
import type { GetProps } from '@types';
import Modal from '@components/Modal';

type Props = Pick<
  GetProps<typeof Modal>,
  | 'header'
  | 'footer'
  | 'children'
  | 'onRequestClose'
  | 'backdropZIndex'
  | 'cancelText'
>;

function LibModal({
  children,
  header,
  footer,
  cancelText,
  backdropZIndex,
  onRequestClose,
}: Props) {
  return (
    <Modal
      isOpen
      style={{ width: 1000, height: 'calc(100% - 60px)' }}
      onRequestClose={onRequestClose}
      header={header}
      footer={footer}
      backdropZIndex={backdropZIndex}
      cancelText={cancelText}
    >
      <div className="flex h-full">{children}</div>
    </Modal>
  );
}

export default LibModal;
